module.exports = __webpack_public_path__ + "img/default-bg-ms.f3ad758b.png";